import { PageTypePortal } from "@/lib/types";

/** Query param for deep-linking into the makeup request wizard from notifications. */
export const MAKEUP_ATTENDANCE_LOG_QUERY = "attendanceLogId";

const UUID_PATTERN =
  /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

export function buildMakeupPortalLink(attendanceLogId?: string | null): string {
  const base = PageTypePortal.Makeups;
  if (!attendanceLogId?.trim()) return base;
  const params = new URLSearchParams({
    [MAKEUP_ATTENDANCE_LOG_QUERY]: attendanceLogId.trim(),
  });
  return `${base}?${params.toString()}`;
}

/** Extract attendance log id embedded in notification copy by backend templates. */
export function extractAttendanceLogIdFromNotificationText(
  ...parts: Array<string | null | undefined>
): string | null {
  for (const part of parts) {
    if (!part) continue;
    const paramMatch = part.match(
      new RegExp(`${MAKEUP_ATTENDANCE_LOG_QUERY}=(${UUID_PATTERN.source})`, "i"),
    );
    if (paramMatch?.[1]) return paramMatch[1];

    const labeledMatch = part.match(
      new RegExp(`attendance[-_\\s]?log[-_\\s]?id[:\\s]+(${UUID_PATTERN.source})`, "i"),
    );
    if (labeledMatch?.[1]) return labeledMatch[1];

    const bareMatch = part.match(UUID_PATTERN);
    if (bareMatch?.[0]) return bareMatch[0];
  }
  return null;
}
